var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('add-waste-offer',[_vm._v("2222")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }